// extracted by mini-css-extract-plugin
export default {"container":"news_container__zJ0jV","text":"news_text__MnA9O"};